module.exports = {
    shelfProductTile: {
        showSaveToListAsLink: false,
        showTags: true,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/shelf-product-tile.js